import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { hd, TicketContextService, UserContextService } from '@nx-fe/services';
import { Activity } from '../../../../ticket/ticket.model';
import { ActivityContextService } from './activity-context';
import { NoteActivityComponent } from './note-activity/note-activity.component';
import { OutboundEmailActivityComponent } from '../outbound-email/outbound-email-activity.component';
import { TicketPageService } from 'app/modules/ticket/ticket-page.service';

/** Defines bindings a component should have to function as an activity template */
export interface IActivityTemplateBindings {
  /** The activity data bound to the component */
  activity: hd.IActivityModel | string;

  /** Indicates whether the note activity is editable or not */
  canEdit: boolean | string;
}

/** Defines the properties and functions bound by the component */
export interface IActivityBindings {
  /** The activity data bound to the component */
  activity: any;

  /** The specified activity type (optional) - used if activity is not provided */
  activityType: any;

  /** The specified activity state (optional) */
  activityState: any;

  /** Invoked when an activity is to be deleted */
  onDelete: any;

  /** Invoked when an activity is to be updated/saved */
  onUpdate: any;

  /** Specifies whether this activity is at the top of a list of activities */
  isHeader: any;

  /** Specifies whether this activity is at the bottom of a list of activities */
  isFooter: any;

  /** Invoked when the activity list needs to be */
  onRefresh: any;

  /** Specifies whether the user can edit the activity by defined with user's permissions, ticket status */
  canEdit: any | boolean;
}

/** Defines the activity component - linking the controller, template, and bindings */
@Component({
  selector: 'xs-activity',
  templateUrl: 'activity.component.html',
  styleUrls: ['activity.component.scss'],
})
export class ActivityComponent implements OnInit {
  transclude: boolean;

  @Input()
  activityTypeId: number;

  @Input()
  activity: Activity;
  @ViewChild(OutboundEmailActivityComponent) EmailActivity: OutboundEmailActivityComponent;

  @Input()
  set activityState(newState: string) {
    if (!this.activityContext) {
      return;
    }
    this.activityContext.setActivityState(newState);
  }

  @Input()
  isHeader: boolean;

  @Input()
  isFooter: boolean;

  @Input()
  canEdit: boolean;

  @Input()
  public isSPPMode: boolean;

  @Output()
  onDelete: EventEmitter<any> = new EventEmitter();

  @Output()
  onUpdate: EventEmitter<any> = new EventEmitter();

  @Output()
  onRefresh: EventEmitter<any> = new EventEmitter();

  @Output() isEditting: EventEmitter<boolean> = new EventEmitter<boolean>();

  activityContext: ActivityContextService;

  @ViewChild(NoteActivityComponent) noteActivity: NoteActivityComponent;

  constructor(
    private userContextService: UserContextService,
    private ticketContextService: TicketContextService,
    private ticketPageService: TicketPageService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.activityContext = this.getActivityContext();
    });
  }

  get isDirty(): boolean {
    return this.activity.isDirty();
  }

  public get canEditAttachments() {
    return this.ticketContextService.canEditTicket();
  }

  updatePrivacyIcon(event) {
    this.activityContext.iconClass = event;
  }

  private getActivityContext() {
    // XTODO: the "new" keyword is a code smell.  Should create a factory service so these won't be so tightly coupled.
    return new ActivityContextService(
      this.userContextService,
      this.activityTypeId,
      this.activity,
      this.activityState,
      this.isHeader,
      this.isFooter,
      this.canEdit,
      this.onDelete,
      this.onUpdate,
      this.onRefresh
    );
  }
}
